// extracted by mini-css-extract-plugin
module.exports = {"container":"file-processing_container__3T5_0","spinnerSize":"file-processing_spinnerSize__3wWIx","spinnerText":"file-processing_spinnerText__1g1eC"};